import { render, staticRenderFns } from "./RegulatoryUpdateWarning.vue?vue&type=template&id=5513d093&scoped=true"
import script from "./RegulatoryUpdateWarning.vue?vue&type=script&lang=ts"
export * from "./RegulatoryUpdateWarning.vue?vue&type=script&lang=ts"
import style0 from "./RegulatoryUpdateWarning.vue?vue&type=style&index=0&id=5513d093&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5513d093",
  null
  
)

export default component.exports